module.exports = __webpack_public_path__ + "static/media/3d_printing_v2.1211849f.png";